import { graphqlRequest } from "../graphqlClient";
import type {
	ForecastDataPointViewConnection,
	ForecastDataPointViewFilterInput,
} from "../models/forecastDataPointView";

export interface ForecastDataPointViewSortInput {
	field: string;
	order: "Ascending" | "Descending";
}

interface ForecastDataPointViewListResponse {
	transactions: {
		forecastDataPointViewList: ForecastDataPointViewConnection;
	};
}

export async function getForecastDataPointsGraphql(
	filter?: ForecastDataPointViewFilterInput,
	first?: number,
	after?: string,
	sort?: ForecastDataPointViewSortInput[],
): Promise<ForecastDataPointViewConnection> {
	const query = `
    query ForecastDataPointViewList($filter: ForecastDataPointViewFilterInput, $first: Int, $after: String, $sort: [ForecastDataPointViewSortSortByInput!]) {
      transactions {
        forecastDataPointViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              date
              openingBalance
              balance
              incoming
              outgoing
              confidenceScore
              contributingLayers
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
	const data = await graphqlRequest<ForecastDataPointViewListResponse>(query, {
		filter,
		first,
		after,
		sort,
	});
	return data.transactions.forecastDataPointViewList;
}

interface ForecastDataPointViewCountResponse {
	transactions: {
		forecastDataPointViewCount: number;
	};
}

export async function getForecastDataPointsCount(
	filter?: ForecastDataPointViewFilterInput,
): Promise<number> {
	const query = `
    query ForecastDataPointViewCount($filter: ForecastDataPointViewFilterInput) {
      transactions {
        forecastDataPointViewCount(filter: $filter)
      }
    }
  `;
	const data = await graphqlRequest<ForecastDataPointViewCountResponse>(query, {
		filter,
	});
	return data.transactions.forecastDataPointViewCount;
}
